import React, { useEffect, useState, useContext, useRef } from 'react';
import { useNavigate } from 'react-router';

import pingItApi from '../api/pingItApi';

import ConditionalInput from './Conditionalnput';
import { AuthContext } from './utils/AuthContext';
import IpInput from './home/IpInput';

import Logo from './img/pingit_logo.png';
import More from './img/more.png';
import Add from './img/add.png';
import Edit from './img/edit.png';
import Delete from './img/delete.png';
// import Close from './img/close.png';
import Logout from './img/logout.png';

import './hostlist.css';
import { useAxiosWithRedirect } from '../api/useAxiosWithRedirect';


const statusInfo = (monitor, status) => {
    if (monitor === 0) return {text: 'Monitor Disattivato', color: '#FFBF00'};
    else return status ? {text: 'Dead',color: '#DC143C'} : {text: 'Alive', color: '#50C878'}; //red green

    
}

const formatData = (dataString) => {
    if(dataString === null) return "n.d.";
    // Creiamo un oggetto Date
    const data = new Date(dataString);

    // Impostiamo il formato italiano
    const dataFormattata = data.toLocaleString('it-IT', {
        year: 'numeric',
        month: 'numeric',      // nome completo del mese
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false       // Imposta il formato a 24 ore
    });

    return dataFormattata === 'Invalid Date' ? dataString : dataFormattata;
}

const setTag = (status) => {
    if(status === 'up') return(<div style={{backgroundColor: '#50C878', color: 'white', fontWeight: 'bold'}}>Up</div>)
    return (<div style={{backgroundColor: '#DC143C', color: 'white', fontWeight: 'bold'}}>Down</div>)
} 

const setCheckbox = (field, value, hostId) => {
    if (value === 0) {
        return(<input type="checkbox" name={field} id={field} disabled/>
    )}
    return (<input type="checkbox" name={field} id={field} defaultChecked disabled/>)    
}

const Home = () => {
    const [hostList, setHostList] = useState([]);
    const [overlay, setOverlay] = useState();

    const isLogged = useRef(true);
    
    const {logout} = useContext(AuthContext);
    const {user} = useContext(AuthContext);

    const navigate = useNavigate();

    const redirectApi = useAxiosWithRedirect();

    const closeOverlay = (e) => {
        if(e.target.id !== 'overlay') return;
        setOverlay()
        Refresh()
    }

    const sendChanges = (id, isNew = false) => {
        const description = document.getElementById('host_desc').value;
        const ip = document.getElementById('host_ip').value;
        const interval = document.getElementById('host_int').value;
        const monitor = document.getElementById('host_monit').checked;
        const notify = document.getElementById('host_notify').checked;
        const recipients = document.getElementById('host_recipients').value;
    
        const query = isNew ? 'hosts/addHost' : 'hosts/editHost';

        if(document.getElementById("host_ip").dataset.valid === 'false') return alert("Indirizzo ip non valido o già monitorato.");

        if(notify && recipients.trim().length === 0) return alert("Specificare almeno una mail.");

        pingItApi.post(query, {
            id,
            description,
            ip,
            interval,
            monitor,
            notify,
            recipients
        }, {withCredentials: true}).then(() => {
            setOverlay();
            Refresh();
        })
        
    }

    const deleteHost = (id) => {
        pingItApi.post('hosts/deleteHost', {
            id
        }, {withCredentials: true}).then(() => {
            setOverlay();
            Refresh();
        })
    }

    const addHost = () => {
        const temp = (
            <div id='overlay' onClick={(e) => closeOverlay(e)} style={{position: 'absolute', width:'100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: '3'}}>
                    <div className='hostDetails addHost' >
                        <h1 style={{marginBottom: '20px'}}>Aggiungi</h1>
                        <table className='hostTable'>
                            <tbody>
                                <tr>
                                    <td>Descrizione</td>
                                    <td> <input style={{width: '95%'}} type="text" name="host_desc" id="host_desc" /></td>
                                </tr>
                                <tr>
                                    <td>Indirizzo</td>
                                    {/* <td> <input style={{width: '95%'}} type="text" name="host_ip" id="host_ip" /></td> */}
                                    <td><IpInput /></td>
                                </tr>
                                <tr>
                                    <td>Intervallo (secondi)</td>
                                    <td> <input style={{width: '95%'}} type="text" name="host_int" id="host_int" /></td>
                                </tr>
                                <tr>
                                    <td>Monitor</td>
                                    <td><input type="checkbox" name="host_monit" id="host_monit" defaultChecked /></td>
                                </tr>   
                                <ConditionalInput />
                            </tbody>
                        </table>
                        <div style={{width: '60%', marginTop: '20px', marginBottom: '20px', display: 'flex', justifyContent: 'center'}}> 
                            <button onClick={() => sendChanges('', true)} className='actionBtn' style={{backgroundColor: '#50C878'}} >Conferma</button>
                        </div>
                    </div>
                </div>

        )
        setOverlay(temp)
    }

    const editHost = (host) => {
        const temp = (
            <div id='overlay' onClick={(e) => closeOverlay(e)} style={{position: 'absolute', width:'100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: '3'}}>
                    <div className='hostDetails addHost'>
                        <h1 style={{marginBottom: '20px'}}>Modifica</h1>
                        {/* <div style={{width: '60%'}}><div className='moreBtn' style={{padding: '2px', margin: 0,marginLeft: 'auto', marginBottom: '10px'}}><img style={{height: '100%'}} src={Close} alt="edit" /></div></div> */}
                        <table className='hostTable'>
                            <tbody>
                                <tr>
                                    <td>Descrizione</td>
                                    <td> <input style={{width: '95%'}} type="text" name="host_desc" id="host_desc" defaultValue={host.description}/></td>
                                </tr>
                                <tr>
                                    <td>Indirizzo</td>
                                    <td> <input style={{width: '95%'}} disabled type="text" name="host_ip" id="host_ip" defaultValue={host.host}/></td>
                                </tr>
                                <tr>
                                    <td>Intervallo (secondi)</td>
                                    <td> <input style={{width: '95%'}} type="text" name="host_int" id="host_int" defaultValue={host.delay}/></td>
                                </tr>
                                <tr>
                                    <td>Monitor</td>
                                    <td><input type="checkbox" name="host_monit" id="host_monit" defaultChecked={host.active} /></td>
                                </tr>  
                                <ConditionalInput currValue={host.recipients} currCheck={host.notify}/> 
                            </tbody>
                        </table>
                        <div style={{width: '60%', marginTop: '20px', marginBottom: '20px', display: 'flex', justifyContent: 'center'}}> 
                            <div className='actionBtn' onClick={() => deleteHost(host.id)} style={{backgroundColor: '#DC143C', marginRight:'10px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px'}}><img style={{height: '80%'}} src={Delete} alt="edit" /></div> 
                            <button className='actionBtn' style={{backgroundColor: '#50C878'}} onClick={() => sendChanges(host.id)}>Conferma</button>
                        </div>
                    </div>
                </div>

        )
        setOverlay(temp)
    }

    const getMore = (host_id) => {
        pingItApi.get(`/hosts/getHost?id=${host_id}`, {withCredentials: true}).then((response) => {
            const host = response.data[0][0];
            const hostLog = response.data[1];
            const status_info = statusInfo(host.active, host.alert);
            const temp = (
                <div id='overlay' onClick={(e) => closeOverlay(e)} style={{position: 'absolute', width:'100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: '3'}}>
                    <div className='hostDetails'>
                        <h1 style={{margin: 0}}>Host</h1>
                        <div style={{width: '60%'}}><div className='moreBtn' onClick={() => editHost(host)} style={{padding: '2px', margin: 0,marginLeft: 'auto'}}><img style={{height: '100%'}} src={Edit} alt="edit" /></div></div>
                        <table className='hostTable'>
                            <tbody>
                                <tr><th>Generali</th></tr>
                                <tr>
                                    <td>Descrizione</td>
                                    <td>{host.description}</td>
                                </tr>
                                <tr>
                                    <td>Indirizzo</td>
                                    <td>{host.host}</td>
                                </tr>
                                <tr>
                                    <td>Intervallo</td>
                                    <td>{host.delay}s</td>
                                </tr>
                                <tr>
                                    <td>Stato</td>
                                    <td style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><p style={{margin: '0', marginLeft: 'auto'}}>{status_info.text}</p><div className='light_indicator' style={{backgroundColor: status_info.color, marginLeft: '5px' }}></div></td>
                                </tr>
                                <tr>
                                    <td>Ultimo down</td>
                                    <td>{formatData(host.offsince)}</td>
                                </tr>
                                <tr>
                                    <td>Media</td>
                                    <td>{host.avg}ms</td>
                                </tr>
                                <tr>
                                    <td>Monitor</td>
                                    <td>{setCheckbox("monitor", host.active, host.id)}</td>
                                </tr>  
                                <tr>
                                    <td>Notifiche</td>
                                    <td>{setCheckbox("notify", host.notify, host.id)}</td>
                                </tr>  
                                <tr><th>Log </th></tr>
                            </tbody>
                        </table>
                        <div style={{maxHeight: '400px', overflowY: 'scroll', width: '60%'}}>
                            <table className="logTable" style={{ borderCollapse: 'collapse'}}>
                                <thead>
                                <tr>
                                    <th>Stato</th>
                                    <th>Data</th>
                                </tr>
                                </thead>
                                <tbody>
                                    {hostLog
                                        .sort((a, b) => new Date(b.date) - new Date(a.date))
                                        .map((log, index) => (
                                            <tr key={index}>
                                                <td style={{ height: '30px', verticalAlign: 'middle' }}>{setTag(log.status)}</td>
                                                <td style={{ height: '30px', verticalAlign: 'middle' }}>{formatData(log.date)}</td>
                                            </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            )
            setOverlay(temp)
        })
    }

    const Refresh = () => {
        if(!isLogged) return;
        redirectApi.get("/hosts/list", {withCredentials: true}).then((response) => {
            setHostList(response.data.map((host) => (
                <tr key={host.id} className='hostRow'>
                <td>{host.description}</td>
                <td style={{fontWeight: 'bold'}}>{host.active ? 'Attivo' : 'Disattivo'}</td>
                <td><div><div className='light_indicator' style={{backgroundColor: statusInfo(host.active, host.alert).color }}></div></div></td>
                <td><div onClick={() => getMore(host.id)} className="moreBtn"><img style={{height: '100%'}} src={More} alt="more" /></div></td> 
             </tr>
            )))
        })

    }

    const handleLogout = async () => {
        try {
            await pingItApi.post("/user/logout", {}, { withCredentials: true });
            logout();
            navigate("/login", { replace: true });
        } catch (err) {
            console.error("Errore nel logout:", err);
        }
    };

    useEffect(() => {
        Refresh();
        const interval = setInterval(() => Refresh(), 5000);
        // Cleanup: quando il componente si smonta o l'effetto si riesegue
        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, []);

    return(
        <div style={{backgroundColor: '#e9f1f7', textAlign: 'center', minHeight:'100vh', height: 'auto', overflow: 'hidden'}}>
            {overlay}
            {/* Logout */}
            <div style={{width: '100%', height: '50px', display: 'flex', justifyContent: 'space-between'}}>
                <p style={{fontWeight: 'bold', color: '#2274A5', marginLeft: '20px', marginTop: '5px', fontSize: '1.6rem'}}>{user["username"]}</p>
                <div onClick={() => handleLogout()} className="moreBtn" style={{cursor: 'pointer' ,backgroundColor: '#2274A5', width: '70px', height: '40px',borderRadius: '15px', marginLeft: 'auto', marginRight: '20px', marginTop: '5px'}}>
                    <img style={{marginTop: '7px', marginLeft: '4px'}} src={Logout} alt="logout" />
                </div>
            </div>
            <img src={Logo} alt="logo" style={{height: '100px'}} />
            {/* Host List */}
            <div className='hostListContaienr'>
                <h1>Lista Host</h1>
                <div style={{width: '90%'}}><div onClick={() => addHost()} className="moreBtn" style={{marginBottom: '10px',height:'40px', width: '80px'}}><img style={{height: '100%'}} src={Add} alt="add" /></div></div>
                <div style={{width: '95%', margin: 'auto', overflowY: 'scroll', maxHeight: '300px'}}>
                    <table style={{width: '100%', borderCollapse: 'collapse', height: '100%'}}>
                        <thead>
                            <tr style={{borderBottom: '1px solid #f0f0f0', margin: '10px', color: '#4d5054'}}>
                                <th>Descrizione</th>
                                <th>Monitor</th>
                                <th>Stato</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {hostList}
                        </tbody>
                    </table>
                </div>   
            </div>
        </div>
    )
}

export default Home;